/**
 * "Reliability & model routing" — Core Concepts (ADR-0074).
 * Reconciled from product/architecture/chat-orchestrator.md, the BYOK surface,
 * and the EU-residency posture.
 */
import type { DocPageContent } from '../types';

export const RELIABILITY_PAGE: DocPageContent = {
  slug: 'reliability',
  titleKey: 'docs.concepts.reliability.title',
  descriptionKey: 'docs.concepts.reliability.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.reliability.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'multi-provider',
      textKey: 'docs.concepts.reliability.multiProvider.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.reliability.multiProvider.body' },

    { kind: 'heading', level: 2, id: 'byok', textKey: 'docs.concepts.reliability.byok.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.reliability.byok.body' },

    { kind: 'heading', level: 2, id: 'eu', textKey: 'docs.concepts.reliability.eu.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.reliability.eu.body' },

    { kind: 'heading', level: 2, id: 'cost', textKey: 'docs.concepts.reliability.cost.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.reliability.cost.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.reliability.next.memory.title',
          textKey: 'docs.concepts.reliability.next.memory.text',
          to: { docSlug: 'memory' },
        },
        {
          titleKey: 'docs.concepts.reliability.next.trust.title',
          textKey: 'docs.concepts.reliability.next.trust.text',
          to: { path: '/trust' },
        },
      ],
    },
  ],
};
